import React from 'react';
import {
  Box,
  Button,
  Flex,
  HStack,
  Icon,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaTrailer } from 'react-icons/fa';
import { useTranslation } from 'i18n/TranslationProvider';

const TrailerCard = ({ trailer, onEdit, onDelete }) => {
  const { t } = useTranslation();
  const cardBg = useColorModeValue(
    'rgba(255, 255, 255, 0.82)',
    'rgba(14, 24, 54, 0.78)',
  );
  const cardBorder = useColorModeValue(
    'rgba(255, 255, 255, 0.95)',
    'rgba(255, 255, 255, 0.12)',
  );
  const titleColor = useColorModeValue('navy.700', 'white');
  const chipBg = useColorModeValue('blackAlpha.50', 'whiteAlpha.100');
  const textColor = useColorModeValue('gray.600', 'gray.300');
  const capacityLabel = trailer?.trailerCapacity
    ? `${trailer.trailerCapacity} ${t('booking.cars')}`
    : t('Not set');
  const cmrLabel = trailer?.cmrInvoiceUploaded ? t('Uploaded') : t('Missing');

  return (
    <Box
      p={{ base: 4, md: 5 }}
      borderWidth="1px"
      borderColor={cardBorder}
      borderRadius="18px"
      bg={cardBg}
      backdropFilter="blur(6px)"
      boxShadow="0 18px 36px rgba(12, 28, 70, 0.12)"
      w="100%"
    >
      <Flex
        direction={{ base: 'column', xl: 'row' }}
        align={{ base: 'stretch', xl: 'center' }}
        justify="space-between"
        gap={4}
      >
        <HStack spacing={3} minW={{ xl: '240px' }}>
          <Flex
            w={10}
            h={10}
            borderRadius="12px"
            bg={chipBg}
            align="center"
            justify="center"
          >
            <Icon as={FaTrailer} w={5} h={5} color="blue.400" />
          </Flex>
          <Text fontWeight="700" fontSize={{ base: 'md', md: 'lg' }} color={titleColor}>
            {trailer.licensePlate}
          </Text>
        </HStack>

        <HStack spacing={2} flexWrap="wrap">
          <HStack px={3} py={1.5} borderRadius="12px" bg={chipBg}>
            <Text color={textColor} fontSize="sm">
              {t('Capacity')}: {capacityLabel}
            </Text>
          </HStack>
          <HStack px={3} py={1.5} borderRadius="12px" bg={chipBg}>
            <Text color={textColor} fontSize="sm">
              {t('CMR Document')}: {cmrLabel}
            </Text>
          </HStack>
        </HStack>

        <HStack
          justify={{ base: 'stretch', md: 'flex-end' }}
          spacing={2}
          w={{ base: '100%', md: 'auto' }}
        >
          <Button
            size="sm"
            variant="outline"
            onClick={() => onEdit(trailer)}
            px={4}
            w={{ base: '100%', md: 'auto' }}
          >
            {t('Edit')}
          </Button>
          <Button
            size="sm"
            colorScheme="red"
            px={4}
            onClick={() => onDelete(trailer._id)}
            w={{ base: '100%', md: 'auto' }}
          >
            {t('Delete')}
          </Button>
        </HStack>
      </Flex>
    </Box>
  );
};

export default TrailerCard;
